(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal2/assets/javascripts/services/data.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal2/assets/javascripts/services/data.js');
"use strict";


const {
  drawHandler
} = svs.components.sport.drawHandler;
const {
  raceHandler
} = svs.components.sport.raceHandler;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  ParticipantTypes
} = svs.components.sport.tipsenShared.constants;
const {
  getPixHandler
} = svs.components.sport.pixHandler;
const {
  POWERPLAY,
  CHALLENGE,
  RACING
} = svs.utils.products.productIds;
const fetchDraw = async (productId, drawNumber) => await drawHandler().fetch(productId, drawNumber, false, true);
const fetchRace = async (productId, drawNumber) => await raceHandler().fetch(productId, drawNumber, false);
const createPix = async _ref => {
  let {
    productId,
    drawNumber,
    systemType,
    systemCost,
    rowPrice,
    branding,
    productSizes,
    isPixMix,
    shouldGenerateNewPix
  } = _ref;
  return await getPixHandler({
    isPixMix
  }).addProduct(productId, product => {
    if (systemType) {
      product.setSystemType(systemType);
    }
    if (rowPrice) {
      product.setRowPrice(rowPrice);
    }
    product.setDrawNumber(drawNumber);
    product.setProductId(productId);
    product.setSystemCost(systemCost);
    product.setBranding(branding);
    product.setProductSizes(productSizes);
  }).fetch({
    productId,
    shouldGenerateNewPix
  });
};
const _normalizeDrawEvent = _ref2 => {
  let {
    event,
    productId
  } = _ref2;
  const {
    eventDescription,
    eventComment,
    eventTypeId,
    participantType,
    outcomes
  } = event;
  const {
    participants
  } = (event === null || event === void 0 ? void 0 : event.match) || {};
  const isPowerplayOrChallenge = [POWERPLAY, CHALLENGE].includes(productId);
  const hasParticipantsData = Array.isArray(participants) && participants.length === 2;
  const isPlayer = participantType === ParticipantTypes.Player;
  const hasOutcomes = Array.isArray(outcomes) && outcomes.every(item => item === null || item === void 0 ? void 0 : item.description);

  const result = {
    captionShort: hasParticipantsData ? participants.map(_ref3 => {
      let {
        mediumName
      } = _ref3;
      return mediumName;
    }).join(' - ') : eventDescription,
    captionLong: hasParticipantsData ? participants.map(_ref4 => {
      let {
        name
      } = _ref4;
      return name;
    }).join(' - ') : eventDescription
  };
  if (isPowerplayOrChallenge && hasParticipantsData) {
    if (isPlayer) {
      result.infoLine = eventComment || 'Vem gör flest mål?';
    } else if (eventComment && eventTypeId !== EventTypeId.EVENT_1X2) {
      result.infoLine = eventComment;
    }
  }
  if (hasOutcomes) {
    result.outcomesAsList = outcomes.map(_ref5 => {
      let {
        description
      } = _ref5;
      return [/[oöÖ]ver/i.test(description) && 'Ö', /under/i.test(description) && 'U', description].find(Boolean);
    });
    if (outcomes.length === 2 && outcomes[1].outcomeNumber === 4) {
      result.outcomesAsList.splice(1, 0, '');
    }
  }
  return result;
};
const normalizeDraw = data => {
  const {
    productId,
    drawNumber,
    regCloseTime,
    drawEvents,
    events
  } = data || {};
  if (productId === RACING) {
    return data;
  }
  if (productId && drawNumber) {
    const _events = drawEvents || events;
    if (!Array.isArray(_events) || _events.length === 0) {
      throw new Error('Missing "draw.drawEvents" in response from draw-API.');
    }
    if (_events.some((item, index) => item.eventNumber !== index + 1)) {
    }
    return {
      productId,
      drawNumber,
      regCloseTime,
      events: _events.map(event => _normalizeDrawEvent({
        event,
        productId
      }))
    };
  }
  throw new Error('Failed to normalize draw');
};
const fetchDrawAndPix = async _ref6 => {
  let {
    productId,
    drawNumber,
    systemType,
    systemCost,
    rowPrice,
    branding,
    productSizes,
    isPixMix,
    shouldGenerateNewPix
  } = _ref6;
  const currentDraw = productId === RACING ? await fetchRace(productId, drawNumber) : await fetchDraw(productId, drawNumber);
  const currentPix = await createPix({
    productId,
    drawNumber,
    systemType,
    systemCost,
    rowPrice,
    branding,
    productSizes,
    isPixMix,
    shouldGenerateNewPix
  });
  const [drawResponse, pixResponse] = await Promise.all([currentDraw, currentPix]);
  const normalizedDrawData = normalizeDraw(drawResponse.getData(), productId);
  return {
    drawResponse: normalizedDrawData,
    pixResponse
  };
};
setGlobal('svs.components.sport.quickplayModal2.services.fetch', {
  fetchDrawAndPix
});

 })(window);